import React, { useEffect } from 'react';
import {
  BrowserRouter as Router, Switch,
} from 'react-router-dom';
import { ProspectFooter } from '@fff-web/fff-global-footer';
import Header from '../Header/Header';
import SocialEcommRegistrationRouterRoutes from '../SocialEcommRegistrationRouter/Routes';
import { useAppContext } from '../../utils/ContextProviders/AppContext';

function SocialEcommRegistration(props: { flags: any }) {
  const { flags } = props;
  const { setFlags } = useAppContext();

  useEffect(() => {
    setFlags(flags);
  }, [flags]);
  return (
    <>
      <Header />
      <Router>
        <Switch>
          <SocialEcommRegistrationRouterRoutes />
        </Switch>
      </Router>
      <ProspectFooter />
    </>
  );
}

export default SocialEcommRegistration;
